/* eslint-disable no-param-reassign */
// import React, { Component } from 'react'
// import ReactDOM from 'react-dom'
import $a from 'axios'
import qs from 'qs'
import { message } from 'antd'
import { setupInterceptors } from '@zhiyi/utils'
import cacheFactory from './cache'
import mes from './message'
import util from './util'
import { getTeamInfo } from '../common/userInfo'

const axios = $a.create()
const downloadAxios = $a.create()

setupInterceptors(axios)
setupInterceptors(downloadAxios)

const { CancelToken } = $a
// 客户端检测运行环境
const baseUrl = '/api/'
const taobaoUrlHost = 'https://item.taobao.com/item.htm?id='
axios.defaults.baseURL = '/api/'
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'comma' })
}

axios.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {}
  }
  if (config.url.indexOf('bi-api') >= 0) {
    config.baseURL = ''
  }
  if (config.url.indexOf('abroad-api') >= 0) {
    config.baseURL = ''
  }
  if (config.url.indexOf('report-api') >= 0) {
    config.baseURL = ''
  }
  if (config.url.indexOf('notify-api') >= 0) {
    config.baseURL = ''
  }
  if (config.url.indexOf('backend-api') >= 0) {
    config.baseURL = ''
  }
  if (/^wb\/|^\/wb\/|^ins\/|^\/ins\/|^image-bus\/|^\/image-bus\/|^install\/blogger\/|^\/install\/blogger\//.test(config.url)) {
    config.baseURL = '/api/zhikuan/'
  }
  if (config.url.indexOf('whale-api')) {
    const teamInfo = getTeamInfo()
    config.headers['TEAM-ID'] = teamInfo?.teamId
    config.headers['USER-ID'] = teamInfo?.userId
    config.headers['USER-NAME'] = encodeURIComponent(teamInfo?.name)
  }

  if (document.title && config?.headers) {
    config.headers.name = encodeURIComponent(document.title)
  }

  if (config.headers) {
    config.headers.type = encodeURIComponent('接口埋点')
    const token = localStorage.getItem('Authorization') || util.getCookie('Authorization')
    if (token) {
      config.headers.Authorization = decodeURIComponent(token)
      config.headers.group = localStorage.group || 1
    }
    config.headers.source_page = window.sessionHistory[0]
    config.headers.target_page = window.sessionHistory[1]
    config.headers.client = 'web'
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
axios.interceptors.response.use((response) => {
  const { data, config } = response

  if (!data) {
    return
  }

  if (data && config?.isDirectReturn) {
    return data // 返回数据
  }

  if (data.success) {
    if (config.status) {
      return data
    }
    return data.result
  }
  if (data.success && config.is) {
    if (data.errorCode === 'UP1') {
      localStorage.setItem('serviceId', data.serviceId)
      if (window.location.pathname !== '/process/1' && window.location.pathname !== '/trend') window.location = '/process/1'
      return
    }
  }
  if (data.errorCode === 'L25') {
    if (window.location.pathname !== '/downLimit') {
      window.location = `/downLimit?content=${data.errorDesc}`
    }
    return
  }
  if (data.errorCode === 'L21') {
    localStorage.removeItem('userAuthCodeList')
    localStorage.removeItem('serviceId')
    // util.clearCookie()
    // const div = document.createElement('div')
    // document.body.appendChild(div)
    // ReactDOM.render(<IpLimit />, div)
    if (window.location.pathname !== '/upperLimit') {
      window.location = '/upperLimit'
    }
    return
  }
  if (data.errorCode === 'L09' && location.pathname !== '/meinian/receive') {
    if (location.pathname === '/price') {
      return { roleLevel: 0 }
    }
    window.location = `/login#${window.location.pathname + window.location.search}`
    return
  }
  if (['G02', 'INS0024', 'P02', 'INS0025', 'INS0027', 'INS0028'].includes(data.errorCode)) {
    return data
  }
  // if (data.errorCode === 'G02' || data.errorCode === 'INS0027' || data.errorCode === 'INS0025' || data.errorCode === 'INS0028') {
  //   return data
  // }
  if (data.errorCode === 'D07' || data.errorCode === 'D12') {
    return data
  }
  if (data.errorCode === 'R1303' || data.errorCode === 'R1304' || data.errorCode === 'R1305' || data.errorCode === 'R1306') {
    message.error(data.errorDesc)
    return false
  }
  if (data.errorCode === 'DLR1403') {
    message.error(data.errorDesc)
    return false
  }
  if (['DLR1702', 'L23', 'L24'].some(m => m === data.errorCode)) {
    message.error(data.errorDesc)
    return false
  }
  if (data?.errorDesc && !config?.ignoreError) {
    message.error(data.errorDesc)
  }
  data.message = data.errorDesc
  return Promise.reject(data)
}, (error) => {
  return rejectError(error)
})

let timeSpan = 0
const rejectError = (error) => {
  if (new Date() - timeSpan < 3000) return Promise.reject(error) // 合并错误提示
  timeSpan = new Date().getTime()
  if (error.response?.status === 403) {
    message.error('该账号未登录')
    setTimeout(() => {
      localStorage.clear()
      util.setCookie('Authorization', '', -1)
      window.location = '/login'
    }, 2000)
    return
  }
  if (error.response?.status === 401) {
  // 其他设备登录逻辑
    if (location.pathname === '/price') {
      return { roleLevel: 0 }
    }
    message.error(error.response?.data?.errorDesc)
    setTimeout(() => {
      localStorage.clear()
      util.setCookie('Authorization', '', -1)
      window.location = `/expired#${window.location.pathname + window.location.search}`
    }, 2000)
    return
  }
  if (error.response?.status === 429) {
    message.error(error.response?.data?.errorDesc)
    return
  }
  if (error.message !== 'axioscancel') {
    message.error('网络不可用，请检查你的网络设置')
  }
  return Promise.reject(error)
}

const tokens = new Map()
function sget(url, params = {}, key = null) {
  if (tokens.has(key)) {
    tokens.get(key).cancel('axioscancel')
  }
  const source = CancelToken.source()
  tokens.set(key, source)
  return axios.get(url, {
    params, cancelToken: source.token
  })
}

// 所有API语义化封装
const request = {
  CACHE_TIME_30DAY: 1000 * 60 * 60 * 24 * 30,
  CACHE_TIME_1H: 1000 * 60 * 60,
  CACHE_TIME_1D: 1000 * 60 * 60 * 24,
  baseUrl,
  track(contents = {}) {
    return axios.post('/user/track-log', {
      code: contents.code || 5000000,
      content: {
        type: '事件埋点',
        source_page: window.sessionHistory[0],
        target_page: window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        client: 'web',
        ...contents
      }
    })
  },
  taobaoUrlHost,
  get: axios.get,
  post: axios.post,
  sget,
  spost(url, params, key) {
    if (tokens.has(key)) {
      tokens.get(key).cancel('axioscancel')
    }
    const source = CancelToken.source()
    tokens.set(key, source)
    return axios.post(url, params, { cancelToken: source.token })
  },
  /**
   * get 请求，如果有缓存使用缓冲数据，不发送请求
   * @param {*} url 请求地址
   * @param {*} params 请求参数
   * @param {*} cacheTime 缓存时间
   * @param {'localStorage'|'sessionStorage'|'indexeddb'|'memory'} cacheType // 缓存类型
   */
  cget(url, params, cacheTime = 30 * 1000, cacheType = 'memory') {
    return this.cacheRequest(url, params, 'get', cacheTime, cacheType)
  },
  /**
   * post 请求，如果有缓存使用缓冲数据，不发送请求
   * @param {*} url 请求地址
   * @param {*} params 请求参数
   * @param {*} cacheTime 缓存时间
   * @param {'localStorage'|'sessionStorage'|'indexeddb'|'memory'} cacheType // 缓存类型 默认'memory'
   */
  cpost(url, params, cacheTime = 30 * 1000, cacheType = 'memory') {
    return this.cacheRequest(url, params, 'post', cacheTime, cacheType)
  },
  async cacheRequest(url, params, method = 'get', cacheTime = 30 * 1000, cacheType = 'memory') {
    const cache = cacheFactory(cacheType)
    const key = url + JSON.stringify(params)
    if (cache.has(key)) {
      const cacheItem = cache.get(key)
      if ((Date.now() - cacheItem.createdAt) > cacheTime) {
        cache.delete(key)
      } else {
        cacheItem.createdAt = Date.now()
        return cacheItem.content
      }
    }
    try {
      const res = await axios(url, { method, data: params, params })
      cache.set(key, {
        content: res,
        createdAt: Date.now()
      })
      return res
    } catch (error) {
      console.error(error)
    }
  },
  formdata: (url, data, onUploadProgress) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress }
    const formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
    }
    return axios.post(url, formData, config)
  },
  async getConfig(key) {
    const res = await axios.get(`/backend-api/sso-api/common/setting/get?key=${key}`)
    return res
  },
  async setConfig(key, value) {
    const res = await axios.get(`/backend-api/sso-api/common/setting/set?${qs.stringify({ value, key })}`,)
    return res
  },
  async downloadBlob(url, name = '', isRandom = true) {
    const res = await request.blob(url, isRandom)
    const _url = window.URL.createObjectURL(res)
    const link = document.createElement('a')
    link.href = _url
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
    return res.data
  },
  async blob(url, isRandom = true) {
    const res = await downloadAxios({
      method: 'get',
      url: `${url}${isRandom ? `?${Math.random()}` : ''}`,
      responseType: 'blob',
    })
    return res.data
  },
  async json(url) {
    const res = await downloadAxios({
      method: 'get',
      url: `${url}?${Math.random()}`,
      responseType: 'json',
    })
    return res.data
  },
  async jsonPost(url, data) {
    const res = await downloadAxios({
      method: 'post',
      url,
      data,
    })
    return res.data
  },
  download: async (url, title) => {
    if (!url) return
    if (url.includes('zhiyi-image-cdn.zhiyitech.cn')) {
      const iframe = document.createElement('iframe')
      iframe.src = `${url}?response-content-type=application/octet-stream&response-content-disposition=attachment%3Bfilename%3D${title.replace(/\//g, '-')}.zip`
      iframe.style.width = '1px'
      iframe.style.height = '1px'
      document.body.appendChild(iframe)
      setTimeout(() => {
        iframe.remove()
      }, 3000)
    } else {
      return downloadAxios({ method: 'get', url: `${url}?${Math.random()}`, responseType: 'blob', baseURL: '/api/' }).then((response) => {
        const blob = response.data
        const a = document.createElement('a')
        a.download = `${title.replace(/\//g, '-')}.xlsx`
        a.href = URL.createObjectURL(blob)
        a.click()
        URL.revokeObjectURL(a.href)
      })
    }
  },
  downloadFromAsync: async (action, params, exc) => {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN) || util.getCookie(process.env.REACT_APP_TOKEN)
    const config = { headers: {
      Authorization: decodeURIComponent(token)
    },
    responseType: 'blob'
    }
    const buffer = await downloadAxios.post(`/api${action}`, params, config)
    const blob = buffer.data
    const a = document.createElement('a')
    const fileName = exc ? `${params.fileName}${exc}` : `${params.fileName}`
    a.setAttribute('download', fileName)
    a.href = URL.createObjectURL(blob)
    a.click()
    URL.revokeObjectURL(a.href)
  },
  downloadFromFormdata: (action, method, params) => {
    const form = document.createElement('form')
    form.setAttribute('action', `/api${action}`)
    form.setAttribute('method', method || 'post')
    form.setAttribute('target', '_self')
    form.setAttribute('enctype', 'multipart/form-data')
    form.style.display = 'none'
    for (const key in params) {
      const field = document.createElement('input')
      field.setAttribute('type', 'hidden')
      field.setAttribute('name', key)
      field.setAttribute('value', params[key])
      form.appendChild(field)
    }
    document.body.appendChild(form)
    form.submit()
    setTimeout(() => {
      form.remove()
    }, 3000)
  },
  downloadFromFormdataAsync: async (action, params, ext = 'xlsx') => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob', }
    const formData = new FormData()
    for (const key in params) {
      formData.append(key, params[key])
    }
    const buffer = await downloadAxios.post(`/api${action}`, formData, config)
    const blob = buffer.data
    const a = document.createElement('a')
    a.download = `${params.fileName}.${ext}`
    a.href = URL.createObjectURL(blob)
    a.click()
    URL.revokeObjectURL(a.href)
  },
  qs(obj) {
    const search = []
    for (const key in obj) {
      if (obj[key] !== undefined) { search.push(`${key}=${obj[key]}`) }
    }
    return search.join('&')
  },
  // 切换店铺监控
  changeShopCollect: (type, shopId) => (type ? axios.get(`/shop/follow-cancel?shopId=${shopId}`) : axios.get(`shop/follow-add?shopId=${shopId}&pathname=${sessionStorage.pathname}`)),
  // 监控店铺
  addShopFollow: (shopId = 0) => axios.get(`shop/follow-add?shopId=${shopId}&pathname=${sessionStorage.pathname}`),
  // 取消监控店铺
  cancelFollow: id => axios.get(`/shop/follow-cancel?shopId=${id}`),
  // 切换商品收藏 (添加/取消)
  changeItemCollect: (type, itemId) => (type ? axios.get(`account/item-collect-cancel?itemId=${itemId}`) : axios.get(`account/item-collect-add?itemId=${itemId}`)),
  // 切换商品对比
  changeItemDiff: (type, itemId) => {
    const result = type ? axios.get(`account/compare-item-cancel?itemId=${itemId}`) : axios.get(`account/compare-item-add?itemId=${itemId}`)
    result.then(() => {
      mes.pub('compare')
    })
    return result
  }
}
export default request

/**
 *
 * @param {'post'|'get'|'sget'|'spost'|'cpost'|'cget'} type
 * @param {string} url
 * @param {...any} args
 * @returns
 */
export const requestAction = (type, url, ...args) => () => request[type](url, ...args)
